import angular from "angular";
import { configureStates } from "../../../core/router/router-helper.provider";

const routes = [{
    state: "payout.payoutPolicyList",
    config: {
        url: "/PayoutPolicyList",
        redirectTo: "payout.policy",
    }
}, {
    state: "payout.policy",
    config: {
        url: "/payout-policies",
        component: "apexPayoutPolicyListContainer",
        resolve: {
            identity: employeeService => {
                'ngInject';
                return employeeService.retrieveIdentity();
            },
            isAdminView: identity => {
                'ngInject';
                //TODO: Replace with specific permissions.
                return identity.IsSiteAdmin || identity.Roles.some(p => p === "Innovage Account");
            }
        },
        redirectTo: (transition) => {
            const permissionGrantService = transition.injector().get("permissionGrantService");
            const divisionState = permissionGrantService.hasPermission("navigation:divisionPayoutPolicyList")
                .then(access => access ? "payout.policy.division" : undefined);
            const icdState = permissionGrantService.hasPermission("navigation:icdPayoutPolicyList")
                .then(access => access ? "payout.policy.icd" : undefined);
            // Resolve access in order. If the division state has a value, go there. Otherwise, wait on the next request
            // If neither are accessible, the parent route should also be inaccessible.
            return divisionState.then(state => {
                return state || icdState;
            })
                .then(state => state || "persisted403");
        }
    }
}, {
    state: "payout.policy.division",
    config: {
        url: "/divisions",
        component: "apexDivisionPayoutPolicyList",
        data: {
            pageHeader: "Payout Policy List",
            permissionKey: "navigation:divisionPayoutPolicyList"
        }
    }
}, {
    state: "payout.policy.icd",
    config: {
        url: "/companies",
        component: "apexIcdCorporationPayoutPolicyList",
        data: {
            pageHeader: "Payout Policy List",
            permissionKey: "navigation:icdPayoutPolicyList"
        }
    }
}];

export const PayoutPolicyRoutingModule = angular
    .module("apex.mainApp.payout.policy.routing", [])
    .run(configureStates(routes))
    .name;
